// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingOverlay_overlay__ViByP","contentBox":"LoadingOverlay_contentBox__52p9R","spinner":"LoadingOverlay_spinner__2ZrBu","rotation":"LoadingOverlay_rotation__rXWvh"};